import React from 'react';
import { connect } from 'react-redux';
import {
    Redirect,
    withRouter,
    Route
} from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import { hasAnyRoleNotExist, setPanelHeight } from "../actions/utils";
import { removeAllCache } from "../actions/actions";
import AdminUserList from '../pages/Admin/UserList/list';
import UserDetail from '../pages/Admin/UserList/detail';
import AdminReportList from '../pages/Admin/ReportList/list';

class AdminLayout extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        setPanelHeight();
        window.addEventListener('load', setPanelHeight);
        window.addEventListener('resize', setPanelHeight);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', setPanelHeight);
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        setPanelHeight();
    }

    render() {
        if (localStorage.getItem('user') == null || hasAnyRoleNotExist("Admin")) {
            localStorage.removeItem('user');
            localStorage.removeItem('userType');
            this.props.dispatch(removeAllCache());
            return (<Redirect
                to={{
                    pathname: "/",
                    state: { from: this.props.location }
                }}
            />
            );
        }

        return (
            <div>
                <Header />
                <Route exact path="/admin/user-list" component={AdminUserList} />
                <Route exact path="/admin/user-list/detail/:id" component={UserDetail} />
                <Route exact path="/admin/report-list" component={AdminReportList} />
                <Footer />
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        app: state.app
    }
}

export default withRouter(connect(mapStateToProps)(AdminLayout))